export const SALES_TEAM_MEMBER_PRODUCTS_PATH = '/sales_team_member/products'
export const SALES_TEAM_MEMBER_DEALS_PATH = '/sales_team_member/deals'
export const SALES_TEAM_MEMBER_DEAL_PATH = '/sales_team_member/deals/:id'
export const SALES_TEAM_MEMBER_DEAL_EDIT_PATH = '/sales_team_member/deals/edit/:id'
export const SALES_TEAM_MEMBER_RELOAD_PATH = '/sales_team_member*'
export const SALES_TEAM_MEMBER_NOT_FOUND_PATH = '*'
export const SALES_TEAM_MEMBER_OVERVIEW_PATH = '/sales_team_member'
export const SALES_TEAM_MEMBER_INVITES_PATH = '/sales_team_member/invites'
export const SALES_TEAM_MEMBER_PROFILE_PATH = '/sales_team_member/profile/edit'
export const SALES_TEAM_MEMBER_SUPPORT_PATH = '/sales_team_member/support'
